// src/pages/Profile/Profile.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useProfile } from '../../hooks/useProfile';
import VideosTab from './components/VideosTab';
import NewsTab from './components/NewsTab';
import SettingsTab from './components/SettingsTab';
import AlertsTab from './components/AlertsTab';
import './Profile.css';

const Profile = () => {
  const location = useLocation();
  
  // Check if there's a state passed from navigation (from widgets)
  const initialTab = location.state?.activeTab || 'videos';
  const [activeTab, setActiveTab] = useState(initialTab);
  
  const {
    loading,
    error,
    videos,
    news,
    alerts,
    fetchVideos,
    fetchNews,
    fetchAlerts
  } = useProfile();

  useEffect(() => {
    // Fetch data based on active tab
    if (activeTab === 'videos') {
      fetchVideos();
    } else if (activeTab === 'news') {
      fetchNews();
    } else if (activeTab === 'alerts') {
      fetchAlerts();
    }
  }, [activeTab]);

  // Update active tab if location state changes
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      // Clear the location state after using it
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="header-content">
          <div className="header-welcome">
            <h1>Welcome back!</h1>
            <p>Track and manage your investments</p>
          </div>
        </div>
      </div>

      <div className="profile-container">
        <div className="profile-tabs">
          <button
            className={`profile-tab ${activeTab === 'videos' ? 'active' : ''}`}
            onClick={() => setActiveTab('videos')}
          >
            <span className="profile-tab-icon">🎹</span>
            <span>Learn</span>
          </button>
          <button
            className={`profile-tab ${activeTab === 'news' ? 'active' : ''}`}
            onClick={() => setActiveTab('news')}
          >
            <span className="profile-tab-icon">📰</span>
            <span>News</span>
          </button>
          <button
            className={`profile-tab ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            <span className="profile-tab-icon">⚙️</span>
            <span>Settings</span>
          </button>
          <button
            className={`profile-tab ${activeTab === 'alerts' ? 'active' : ''}`}
            onClick={() => setActiveTab('alerts')}
          >
            <span className="profile-tab-icon">🔔</span>
            <span>Alerts</span>
          </button>
        </div>

        <div className="profile-content">
          {activeTab === 'videos' && (
            <VideosTab 
              videos={videos} 
              loading={loading} 
              error={error} 
            />
          )}
          {activeTab === 'news' && (
            <NewsTab 
              news={news} 
              loading={loading} 
              error={error} 
            />
          )}
          {activeTab === 'settings' && <SettingsTab />}
          {activeTab === 'alerts' && (
            <AlertsTab 
              alerts={alerts} 
              loading={loading} 
              error={error} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;